import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { withLatestFrom } from "rxjs/operators";
import { ReportExportService } from "../../api/services";
import { ParamFilter, PowerbiReportEmbedComponent } from "../../elements/powerbi-report-embed/powerbi-report-embed.component";
import { GlobalApp } from "../../tools/global";

@Component({
  selector: "embed-report-component",
  templateUrl: "./embed-report.component.html"
})
export class EmbedReportComponent implements AfterViewInit {

  @ViewChild(PowerbiReportEmbedComponent) powerBi: PowerbiReportEmbedComponent;
  public showReport: boolean = false;
  public isInvalid: boolean = false;
  public isExpired: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private app: GlobalApp,
    private reportExportService: ReportExportService
  ) {
    app.setFullScreenMode();
  }

  ngAfterViewInit() {
    this.route.url.pipe(
      withLatestFrom(this.route.paramMap, this.route.queryParamMap)
    ).subscribe(([url, param, query]) => {
      var embedToken: string = param.get('embedToken');
      this.reportExportService.reportExportGetEmbedReportDetails(embedToken).subscribe((result) => {

        let paramFilter: ParamFilter | undefined; 

        if (
          query.get('zipCode') ||
          query.get('cbsaCode') ||
          query.get('onetCode') ||
          query.get('jobTitle') ||
          query.get('indeedCompany') ||
          query.get('companyKey') ||
          query.get('organizationId') ||
          query.get('naicsCode') ||
          query.get('dateRangeStart') ||
          query.get('dateRangeEnd')
        ) {
          paramFilter = {
            zipCode: query.get('zipCode'),
            cbsaCode: query.get('cbsaCode'),
            onetCode: query.get('onetCode'),
            jobTitle: query.get('jobTitle'),
            indeedCompany: query.get('indeedCompany'),
            orgId: query.get('organizationId'),
            companyKey: query.get('companyKey'),
            naicsCode: query.get('naicsCode'),
            dateRangeStart: query.get('dateRangeStart'),
            dateRangeEnd: query.get('dateRangeEnd')
          };
          }

        if (!result.valid) {
          this.isInvalid = true;
        } else if (!result.subscriptionValid) {
          this.isExpired = true;
        } else {
          this.reportExportService.reportExportLogWidgetUsage({
            embedId: embedToken,
            queryParameters: JSON.stringify(paramFilter)
          }).subscribe((_) => {
            this.powerBi.loadEmbeddedState(false, result.reportEmbeddedExport, [], result.reportSource, result.reportEmbeddedType, false, null, paramFilter);
            this.showReport = true;
          });
        }
      });
    });
  }
}
